import CryptoJS from "crypto-js";

const salt = 'abc&#*'

/**
 * 加密密码
 * @param password
 * @returns {*}
 */
const encryptPassword = (password) => {
    return CryptoJS.SHA256(password + salt).toString()
}

export {
    encryptPassword
}